<div class="mob-pacotes mob-box-container">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div
          class="mob-title-3 text-center mb-40"
          *ngIf="VO?.bennefits_section?.title"
          [innerHtml]="VO?.bennefits_section?.title"
        ></div>
        <div class="mob-servicos" *ngIf="VO?.bennefits_price_section">
          <div
            class="mob-title-2 text-center mb-24 mb-lg-8"
            [innerHtml]="VO?.bennefits_price_section?.title"
          ></div>
          <div
            class="mob-title-3 text-center mb-24 mb-lg-8"
            [innerHtml]="VO?.bennefits_price_section?.description"
          ></div>
          <div
            class="mob-title-2 mob-boston text-center"
            [innerHtml]="VO?.bennefits_price_section?.subtitle"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
